 <div class="container">
        <h1>About Us</h1>
        <h2>Clorent Factory Private Limited</h2>
        <p>
            Clorent Factory Private Limited is a technology-driven company specializing in innovative software solutions for the real estate industry. Our expertise spans across mobile applications for <strong>Apple (iOS)</strong> and <strong>Android</strong> platforms, as well as robust web-based software, empowering real estate professionals and businesses to manage their operations efficiently and seamlessly.
        </p>
        <h2>Our Mission</h2>
        <p>
            Our mission is to revolutionize the real estate sector with cutting-edge digital products that streamline property management, enhance customer experience, and drive business growth. We aim to bridge the gap between technology and real estate, making property transactions smarter, faster, and more transparent.
        </p>
        <h2>What We Do</h2>
        <ul class="values-list">
            <li>Develop mobile apps for property listings, lead management, builder project management, and client engagement.</li>
            <li>Build web software platforms for real estate agencies, builders, and property managers.</li>
            <li>Integrate advanced analytics, reporting, and automation tools for efficient operations.</li>
            <li>Provide secure, scalable, and user-friendly technology tailored to the real estate domain.</li>
            <li>Offer ongoing support and updates to ensure our clients stay ahead in the digital landscape.</li>
        </ul>
        <h2>Why Choose Us?</h2>
        <ul class="values-list">
            <li>Industry-focused solutions built by experts.</li>
            <li>Cross-platform support: iOS, Android, and Web.</li>
            <li>Commitment to innovation, security, and reliability.</li>
            <li>Customer-centric approach and dedicated support.</li>
            <li>Proven track record with satisfied clients in real estate.</li>
        </ul>
        
    </div>
